import { AnalyticsGender, Gender } from '@best-athletes/ba-types';
export function getAnalyticsGender(value: Gender): AnalyticsGender | null{
	if(value === Gender.Male) return "M";
	if(value === Gender.Female) return "F";
	return null;
}
